import lodash from 'lodash';
import moment from 'moment';
import 'moment/locale/fi';
import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils from 'react-day-picker/moment';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setSubNavbar } from '../actions/navbar';
import {
  requestDatapickTasks,
  requestDatapickTasksAll,
  requestGroupedTasks,
  requestGroupedTasksAll,
  requestInstallationDocumentTasks,
  requestInstallationDocumentTasksAll,
  requestIssues,
  requestIssuesAll,
  requestTasks,
  requestTasksAll,
} from '../actions/servicereport';
import '../components/forms/Button.css';
import '../components/forms/DayPickerInput.css';
import Icon from '../components/forms/Icon';
import Input from '../components/forms/Input';
import RadioButton from '../components/forms/RadioButton';
import Select from '../components/forms/Select';
import DatapickTable from '../components/servicereport/DatapickTable';
import ExportDatapickExcelButton from '../components/servicereport/ExportDatapickExcelButton';
import ExportExcelButton from '../components/servicereport/ExportExcelButton';
import ExportGroupedTaskExcelButton from '../components/servicereport/ExportGroupedTaskExcelButton';
import ExportInstallationDocumentExcelButton from '../components/servicereport/ExportInstallationDocumentExcelButton';
import ExportIssuesExcelButton from '../components/servicereport/ExportIssuesExcelButton';
import GroupedTaskTable from '../components/servicereport/GroupedTaskTable';
import InstallationDocumentTable from '../components/servicereport/InstallationDocumentTable';
import IssueTable from '../components/servicereport/IssueTable';
import TaskTable from '../components/servicereport/TaskTable';
import CloseIcon from '../images/close_red.png';
import NewIcon from '../images/new.png';
import { getLocalizedDateTime, getLocalizedString } from '../localization/LocalizedString';
import './Main.css';
import './ServiceReport.css';
import dayjs from 'dayjs';

const getSortedAndLocalizedTasks = (currentLanguage, tasks) => {
  if (tasks.length > 0) {
    const sortedTasks = tasks.slice().sort((a, b) => {
      const aDate = new Date(a.totalEndTime);
      const bDate = new Date(b.totalEndTime);

      if (aDate > bDate) {
        return -1;
      }
      if (bDate > aDate) {
        return 1;
      }
      return 0;
    });

    return sortedTasks.map((task) => {
      const newTask = lodash.cloneDeep(task);
      newTask.localizedServiceName = getLocalizedString(task.serviceName, currentLanguage);
      newTask.localizedEndDate = getLocalizedDateTime(new Date(task.totalEndTime), currentLanguage);
      if (newTask.additionalInfo && newTask.additionalInfo.length > 0) {
        let text = '';
        newTask.additionalInfo.forEach((info) => {
          if (typeof info === 'string') {
            text += `${info};`;
          }
        });
        newTask.parsedInfo = text;
      } else {
        newTask.parsedInfo = '';
      }
      return newTask;
    });
  }
  return tasks;
};

class ServiceReport extends React.Component {
  VIEW_TYPE_USER = Object.freeze({
    task: 'task',
    installationDocument: 'installationDocument',
  });

  VIEW_TYPE = Object.freeze({
    task: 'task',
    issue: 'issue',
    grouped: 'grouped',
    datapick: 'datapick',
    installationDocument: 'installationDocument',
  });

  constructor(props) {
    super(props);

    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    const today = new Date();
    this.state = {
      viewType: this.VIEW_TYPE.task,
      start: moment()
        .startOf('day')
        .toDate(),
      editStartDate: MomentLocaleUtils.formatDate(today, 'DD.MM.YYYY', props.currentLanguage),
      end: moment()
        .endOf('day')
        .toDate(),
      editEndDate: MomentLocaleUtils.formatDate(today, 'DD.MM.YYYY', props.currentLanguage),
      page: 1,
      isLastPage: false,
      serviceReportFilterRowId: 0,
      serviceReportFilterRowIds: [],
      excelLoading: false,
      isDataLoading: false,
      isExcelReady: false,
      componentLoaded: false,
    };
  }

  componentDidMount() {
    const { viewType } = this.state;
    const urlParts = window.location.href.split('/');
    const reportType = urlParts[(urlParts.length - 2)];

    if (this.props.location.state !== undefined) {
      setTimeout(() => {
        const { installationDate = null, installationCode = null } = this.props.location.state;

        this.setState({
          editStartDate: MomentLocaleUtils.formatDate(installationDate, 'DD.MM.YYYY', this.props.currentLanguage),
          editEndDate: MomentLocaleUtils.formatDate(installationDate, 'DD.MM.YYYY', this.props.currentLanguage),
          start: dayjs(installationDate).format('ddd MMM DD YYYY HH:mm:ssZ[Z]'),
          end: dayjs(installationDate).format('ddd MMM DD YYYY HH:mm:ssZ[Z]'),
        });
        this.setState({
          viewType: (reportType === 'installationDocument' ? 'installationDocument' : viewType),
        });

        document.getElementsByClassName('add-filter')[0].click();
        document.getElementsByClassName('report-filter-value')[0].value = installationCode;
        document.getElementsByClassName('end-customer').item(0).value = 'shipmentId';
        document.getElementsByClassName('report-search')[0].click();
      }, 300);
    }
  }

  componentDidUpdate() {
    const {
      translate,
      setSubNavbar,
    } = this.props;

    setSubNavbar({
      title: [
        translate('navigation.service_report'),
      ],
    });

    const { componentLoaded } = this.state;
    if (componentLoaded === false) {
      const urlParts = window.location.href.split('/');
      if (urlParts[(urlParts.length - 1)] === 'servicereport') {
        const today = new Date();
        this.setState({
          viewType: 'task',
          componentLoaded: true,
          editStartDate: MomentLocaleUtils.formatDate(today, 'DD.MM.YYYY', this.props.currentLanguage),
          editEndDate: MomentLocaleUtils.formatDate(today, 'DD.MM.YYYY', this.props.currentLanguage),
          start: dayjs(today).format('ddd MMM DD YYYY HH:mm:ssZ[Z]'),
          end: dayjs(today).format('ddd MMM DD YYYY HH:mm:ssZ[Z]'),
        });
        if (document.getElementsByClassName('order-service-site-row-filter-delete').length > 0) {
          document.getElementsByClassName('order-service-site-row-filter-delete')[0].click();
        }
      }
    }
  }

  componentWillMount() {
    this.performSearch();
  }

  viewTypeChanged = (evt) => {
    this.setState({
      viewType: evt.target.value,
    }, () => this.requestServiceReport(1));
  };

  startDateChanged = (date, modifiers, dayPickerInput) => {
    const {
      editStartDate,
    } = this.state;

    const selectedDate = dayjs(date).format('DD.MM.YYYY');
    let startDate = date;

    if (startDate === undefined) {
      const momentObj = moment(dayPickerInput.getInput().value.trim(), 'DD.MM.YYYY');
      const showDate = moment(momentObj).format('YYYY-MM-DD');
      startDate = dayjs(showDate).format('ddd MMM DD YYYY HH:mm:ssZ[Z]');
    }

    this.setState({
      editStartDate: selectedDate,
      start: startDate || null,
    });

    if (selectedDate === editStartDate) {
      this.startDateRef.current.state.value = selectedDate;
    }
  };

  endDateChanged = (date, modifiers, dayPickerInput) => {
    const {
      editEndDate,
    } = this.state;

    const selectedDate = dayjs(date).format('DD.MM.YYYY');
    let endDate = date;

    if (endDate === undefined) {
      const momentObj = moment(dayPickerInput.getInput().value.trim(), 'DD.MM.YYYY');
      const showDate = moment(momentObj).format('YYYY-MM-DD');
      endDate = dayjs(showDate).format('ddd MMM DD YYYY HH:mm:ssZ[Z]');
    }

    this.setState({
      editEndDate: selectedDate,
      end: endDate || null,
    });

    if (selectedDate === editEndDate) {
      this.endDateRef.current.state.value = selectedDate;
    }
  };

  createFormDataJsonObj = (form) => {
    const {
      serviceReportFilterRowIds,
    } = this.state;

    const formData = new FormData(form);
    const jsonObj = {};

    serviceReportFilterRowIds.forEach((id) => {
      const formKeySelect = `serviceReportFilters[${id}].serviceReportSelect`;
      const formKeyInput = `serviceReportFilters[${id}].serviceReportInputText`;
      const selectValue = formData.get(formKeySelect);
      jsonObj[selectValue] = formData.get(formKeyInput);
    });

    return jsonObj;
  };

  isLastPageForView = () => {
    const { viewType } = this.state;
    const {
      tasks,
      issues,
      groupedTasks,
      datapickTasks,
      installationDocumentTasks,
    } = this.props;

    switch (viewType) {
      case this.VIEW_TYPE.grouped:
        return groupedTasks.length === 0;
      case this.VIEW_TYPE.datapick:
        return datapickTasks.length === 0;
      case this.VIEW_TYPE.installationDocument:
        return installationDocumentTasks.length === 0;
      case this.VIEW_TYPE.issue:
        return issues.length === 0;
      case this.VIEW_TYPE.task:
        return tasks.length === 0;
      default:
        return false;
    }
  };

  onDataSuccess = () => {
    this.setState({
      isDataLoading: false,
      isLastPage: this.isLastPageForView(),
    });
  };

  onDataError = () => {
    this.setState({
      isDataLoading: false,
      isLastPage: false,
    });
  };

  firstClicked = () => {
    this.requestServiceReport(1);
  };

  prevClicked = () => {
    const { page } = this.state;

    this.requestServiceReport(page - 1);
  };

  nextClicked = () => {
    const { page } = this.state;

    this.requestServiceReport(page + 1);
  };

  performSearch = () => {
    this.requestServiceReport(1);
  };

  requestServiceReport = (page) => {
    this.setState({
      page,
    });

    const {
      viewType,
      start,
      end,
    } = this.state;

    const jsonObj = this.createFormDataJsonObj(document.forms.searchForm);
    this.setState({
      isDataLoading: true,
    });

    const restStart = start == null
      ? null
      : moment(start).toISOString();
    const restEnd = end == null
      ? null
      : moment(end).toISOString();

    switch (viewType) {
      case this.VIEW_TYPE.task:
        this.props.requestTasks(restStart, restEnd, page, jsonObj, this.onDataError, this.onDataSuccess);
        break;
      case this.VIEW_TYPE.issue:
        this.props.requestIssues(restStart, restEnd, page, jsonObj, this.onDataError, this.onDataSuccess);
        break;
      case this.VIEW_TYPE.grouped:
        this.props.requestGroupedTasks(restStart, restEnd, page, jsonObj, this.onDataError, this.onDataSuccess);
        break;
      case this.VIEW_TYPE.datapick:
        this.props.requestDatapickTasks(restStart, restEnd, page, jsonObj, this.onDataError, this.onDataSuccess);
        break;
      case this.VIEW_TYPE.installationDocument:
        this.props.requestInstallationDocumentTasks(restStart, restEnd, page, jsonObj, this.onDataError, this.onDataSuccess);
        break;
      default:
      // no action;
    }
  };

  onExcelSuccess = () => {
    this.setState({
      excelLoading: false,
      isExcelReady: true,
    });
  };

  onExcelError = () => {
    this.setState({
      excelLoading: false,
    });
  };

  performExcelExport = (evt) => {
    evt.preventDefault();

    const {
      viewType,
      start,
      end,
    } = this.state;

    this.setState({
      excelLoading: true,
    });

    const jsonObj = this.createFormDataJsonObj(document.forms.searchForm);
    const restStart = start == null
      ? null
      : moment(start).toISOString();
    const restEnd = end == null
      ? null
      : moment(end).toISOString();
    switch (viewType) {
      case this.VIEW_TYPE.task:
        this.props.requestTasksAll(restStart, restEnd, jsonObj, this.onExcelError, this.onExcelSuccess);
        break;
      case this.VIEW_TYPE.issue:
        this.props.requestIssuesAll(restStart, restEnd, jsonObj, this.onExcelError, this.onExcelSuccess);
        break;
      case this.VIEW_TYPE.grouped:
        this.props.requestGroupedTasksAll(restStart, restEnd, jsonObj, this.onExcelError, this.onExcelSuccess);
        break;
      case this.VIEW_TYPE.datapick:
        this.props.requestDatapickTasksAll(restStart, restEnd, jsonObj, this.onExcelError, this.onExcelSuccess);
        break;
      case this.VIEW_TYPE.installationDocument:
        this.props.requestInstallationDocumentTasksAll(restStart, restEnd, jsonObj, this.onExcelError, this.onExcelSuccess);
        break;
      default:
      // no action
    }
  };

  renderExcelButton = () => {
    const { isDataLoading, excelLoading, page } = this.state;
    const { translate } = this.props;
    const title = excelLoading
      ? translate('service_report.search.loading')
      : translate('service_report.search.excel');
    return (
      <button type="button"
              className="shipment-button form-button form-input-shadow"
              onClick={this.performExcelExport}
              disabled={isDataLoading || excelLoading || (this.isLastPageForView() && page === 1)}>
        {excelLoading && (
          <i className="fa fa-refresh fa-spin"
             style={{ marginRight: '5px' }} />
        )}
        <span>{title}</span>
      </button>
    );
  };

  renderExcelData(items) {
    if (items.length === 0) {
      return null;
    }

    const { translate, currentLanguage, session: { isAdmin = false } } = this.props;
    const { viewType } = this.state;
    this.setState({
      isExcelReady: false,
    });

    switch (viewType) {
      case this.VIEW_TYPE.task:
        return (
          <ExportExcelButton isAdmin={isAdmin} translate={translate} data={items} />
        );
      case this.VIEW_TYPE.issue:
        return (
          <ExportIssuesExcelButton currentLanguage={currentLanguage} translate={translate} data={items} />
        );
      case this.VIEW_TYPE.grouped:
        return (
          <ExportGroupedTaskExcelButton currentLanguage={currentLanguage} translate={translate} data={items} />
        );
      case this.VIEW_TYPE.datapick:
        return (
          <ExportDatapickExcelButton currentLanguage={currentLanguage} translate={translate} data={items} />
        );
      case this.VIEW_TYPE.installationDocument:
        return (
          <ExportInstallationDocumentExcelButton currentLanguage={currentLanguage} translate={translate} data={items} />
        );
      default:
        return null;
    }
  }

  getOptionsBasedOnViewType(viewType) {
    let options = [];
    switch (viewType) {
      case this.VIEW_TYPE.task:
        options = [
          'userId',
          'customerName',
          'endCustomer',
          'address',
          'city',
          'serviceSite',
        ];
        break;
      case this.VIEW_TYPE.issue:
        options = [
          'type',
          'description',
          'customerName',
          'endCustomer',
          'address',
          'city',
          'serviceSite',
        ];
        break;
      case this.VIEW_TYPE.grouped:
        options = [
          'customerName',
          'endCustomer',
          'address',
          'city',
        ];
        break;
      case this.VIEW_TYPE.datapick:
        options = [
          'userId',
          'employeeId',
          'customerName',
          'endCustomer',
          'address',
          'city',
          'serviceSite',
          'productId',
        ];
        break;
      case this.VIEW_TYPE.installationDocument:
        options = [
          'userId',
          'employeeId',
          'consignorName',
          'customerName',
          'terminal',
          'endCustomer',
          'address',
          'city',
          'shipmentId',
        ];
        break;
      default:
      // ignore
    }
    return options;
  }

  renderServiceSiteRow = (rowNumber, id, allowDelete) => {
    const { translate } = this.props;
    const { viewType } = this.state;

    const options = this.getOptionsBasedOnViewType(viewType);

    const formInputs = (
      <div className="row">
        <div className="col-sm-3">
          <Select
            name={`serviceReportFilters[${id}].serviceReportSelect`}
            required
            data={options.map((item) => ({
              value: item,
              text: translate(`service_report.filter.options.${item}`),
            }))} />
        </div>
        <div className="col-sm-8">
          <div className="form-select-input">
            <Input
              className="report-filter-value"
              name={`serviceReportFilters[${id}].serviceReportInputText`}
              placeholder={translate('service_report.search.identification')}
              required />
          </div>
        </div>
      </div>
    );

    return (
      <div className="order-service-site-row-filter" key={id}>
        <div className="fit-content">
          <h4 className="primary-color inline-block bold" style={{ paddingTop: '0.7em' }}>{`${rowNumber + 1}.`}</h4>
        </div>
        <div className="order-service-site-row-inputs">
          {formInputs}
        </div>
        <div className="fit-content">
          <div className={`order-service-site-row-filter-delete clickable ${allowDelete ? '' : 'invisible'}`}
               onClick={() => this.deleteServiceSiteRow(rowNumber)}>
            <Icon className="no-margin" src={CloseIcon} />
          </div>
        </div>
      </div>
    );
  };

  appendServiceReportFilterRow = () => {
    const { serviceReportFilterRowIds } = this.state;
    let { serviceReportFilterRowId } = this.state;
    serviceReportFilterRowId++;

    this.setState({
      serviceReportFilterRowId,
      serviceReportFilterRowIds: [
        ...serviceReportFilterRowIds,
        serviceReportFilterRowId,
      ],
    });
  };

  deleteServiceSiteRow = (rowNumber) => {
    const { serviceReportFilterRowIds: rowIdsState } = this.state;

    const serviceReportFilterRowIds = rowIdsState.slice();
    serviceReportFilterRowIds.splice(rowNumber, 1);

    this.setState({
      serviceReportFilterRowIds,
    });
  };

  renderServiceSites = () => {
    const { translate } = this.props;
    const { serviceReportFilterRowIds } = this.state;

    return (
      <div>
        <div>
          <div className="col-sm-12">
            {serviceReportFilterRowIds.map((serviceReportFilterRowId, rowNumber) => this.renderServiceSiteRow(rowNumber, serviceReportFilterRowId, true))}
          </div>
        </div>

        <div>
          <div className="col-sm-12 vertical-middle clickable add-filter"
               onClick={this.appendServiceReportFilterRow}>
            <Icon src={NewIcon} />
            <h6 className="primary-color inline-block bold">
              {translate('append_additional_filter_row')}
            </h6>
          </div>
        </div>
      </div>
    );
  };

  renderNavigation = () => {
    const { page, isLastPage, isDataLoading } = this.state;
    const { translate } = this.props;

    return (
      <div className="col-sm-12"
           style={{ textAlign: 'right', paddingTop: 15, paddingBottom: 25 }}>
        <button className="button-link primary-color inline-block bold"
                disabled={page === 1 || isDataLoading}
                onClick={this.firstClicked}
                type="button">
          {translate('service_report.search.first_page')}
        </button>
        <button className="button-link primary-color inline-block bold"
                disabled={page === 1 || isDataLoading}
                onClick={this.prevClicked}
                style={{ padding: '0 0 0 15px' }}
                type="button">
          {translate('service_report.search.previous_page')}
        </button>
        <span className="primary-color inline-block bold"
              style={{ padding: '0 0 0 15px' }}>
          {page}
        </span>
        <button className="button-link primary-color inline-block bold"
                disabled={isLastPage || isDataLoading}
                onClick={this.nextClicked}
                style={{ padding: '0 0 0 15px' }}
                type="button">
          {translate('service_report.search.next_page')}
        </button>
      </div>
    );
  };

  renderViewTypeSelector = () => {
    const { session: { isAdmin = false } } = this.props;
    const { translate } = this.props;
    const { viewType } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <label>{translate('service_report.search.label_type')}</label>
          </div>
        </div>
        <div className="row controls">
          <div className="col-sm-12">
            {isAdmin
              ? Object.keys(this.VIEW_TYPE)
                .map((it) => (
                  <label key={it}>
                    <RadioButton name="type"
                                 value={it}
                                 checked={it === viewType}
                                 onChange={this.viewTypeChanged} />
                    {translate(`service_report.search.type_${it}`)}
                  </label>
                ))
              : Object.keys(this.VIEW_TYPE_USER)
                .map((it) => (
                  <label key={it}>
                    <RadioButton name="type"
                                 value={it}
                                 checked={it === viewType}
                                 onChange={this.viewTypeChanged} />
                    {translate(`service_report.search.type_${it}`)}
                  </label>
                ))}
          </div>
        </div>
      </div>
    );
  };

  renderFilterMainRow = () => {
    const {
      translate,
      currentLanguage,
    } = this.props;
    const {
      isDataLoading,
      editStartDate,
      editEndDate,
    } = this.state;

    const title = isDataLoading
      ? translate('service_report.search.loading')
      : translate('service_report.search.btn');

    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <label>{translate('service_report.search.label_range')}</label>
          </div>
        </div>
        <div className="row controls">
          <div className="col-sm-12" style={{ paddingBottom: '1em' }}>
            <DayPickerInput onDayChange={this.startDateChanged}
                            ref={this.startDateRef}
                            value={editStartDate}
                            placeholder="DD.MM.YYYY"
                            required
                            dayPickerProps={{
                              disabledDays: {
                                after: new Date(),
                              },
                              locale: currentLanguage,
                              localeUtils: MomentLocaleUtils,
                              todayButton: translate('service_report.search.today'),
                            }} />
            <span className="range-separator">&mdash;</span>
            <DayPickerInput onDayChange={this.endDateChanged}
                            ref={this.endDateRef}
                            placeholder="DD.MM.YYYY"
                            required
                            value={editEndDate}
                            dayPickerProps={{
                              disabledDays: {
                                after: new Date(),
                              },
                              locale: currentLanguage,
                              localeUtils: MomentLocaleUtils,
                              todayButton: translate('service_report.search.today'),
                            }} />
            <button type="button"
                    className="shipment-button form-button form-input-shadow report-search"
                    onClick={this.performSearch}
                    disabled={isDataLoading}>
              {isDataLoading && (
                <i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }} />
              )}
              <span>{title}</span>
            </button>
            {this.renderExcelButton()}
          </div>
        </div>
      </div>
    );
  };

  renderExcelResults = () => {
    const { viewType, isExcelReady } = this.state;

    if (!isExcelReady) {
      return null;
    }

    const {
      currentLanguage,
      tasksAll,
      issuesAll,
      groupedTasksAll,
      datapickTasksAll,
      installationDocumentTasksAll,
    } = this.props;

    const localizedTasksAll = getSortedAndLocalizedTasks(currentLanguage, tasksAll);

    // there is no need to check if user is admin as non-admin has only this.VIEW_TYPE.task variant without other options.
    switch (viewType) {
      case this.VIEW_TYPE.task:
        return this.renderExcelData(localizedTasksAll);
      case this.VIEW_TYPE.issue:
        return this.renderExcelData(issuesAll);
      case this.VIEW_TYPE.grouped:
        return this.renderExcelData(groupedTasksAll);
      case this.VIEW_TYPE.datapick:
        return this.renderExcelData(datapickTasksAll);
      case this.VIEW_TYPE.installationDocument:
        return this.renderExcelData(installationDocumentTasksAll);
      default:
        return null;
    }
  };

  renderData = () => {
    const {
      tasks,
      issues,
      groupedTasks,
      datapickTasks,
      installationDocumentTasks,
    } = this.props;
    const { viewType, isDataLoading, page } = this.state;
    switch (viewType) {
      case this.VIEW_TYPE.task:
        return <TaskTable data={tasks} isLoading={isDataLoading} />;
      case this.VIEW_TYPE.issue:
        return <IssueTable data={issues} isLoading={isDataLoading} requestReport={this.requestServiceReport} page={page} />;
      case this.VIEW_TYPE.grouped:
        return <GroupedTaskTable data={groupedTasks} isLoading={isDataLoading} />;
      case this.VIEW_TYPE.datapick:
        return <DatapickTable data={datapickTasks} isLoading={isDataLoading} />;
      case this.VIEW_TYPE.installationDocument:
        return <InstallationDocumentTable data={installationDocumentTasks} isLoading={isDataLoading} />;
      default:
        return null;
    }
  };

  render() {
    return (
      <div>
        <div className="container">
          <div className="row searchFilters">
            <form id="searchForm" onSubmit={this.performSearch}>
              <div className="col-sm-2">
                {this.renderViewTypeSelector()}
              </div>
              <div className="col-sm-10">
                {this.renderFilterMainRow()}
              </div>
              <div className="col-sm-10">
                {this.renderServiceSites()}
              </div>
              {this.renderExcelResults()}
            </form>
          </div>
        </div>
        <div>
          {this.renderNavigation()}
          <table className="report-table-container">
            <tr>
              <td className="report-table-container-td">
                {this.renderData()}
              </td>
            </tr>
          </table>
          {this.renderNavigation()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  tasks: state.serviceReport.tasks,
  tasksAll: state.serviceReport.tasksAll,
  groupedTasks: state.serviceReport.groupedTasks,
  groupedTasksAll: state.serviceReport.groupedTasksAll,
  datapickTasks: state.serviceReport.datapickTasks,
  datapickTasksAll: state.serviceReport.datapickTasksAll,
  installationDocumentTasks: state.serviceReport.installationDocumentTasks,
  installationDocumentTasksAll: state.serviceReport.installationDocumentTasksAll,
  issues: state.serviceReport.issues,
  issuesAll: state.serviceReport.issuesAll,
  session: state.session,
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setSubNavbar,
  requestTasks,
  requestTasksAll,
  requestIssues,
  requestIssuesAll,
  requestGroupedTasks,
  requestGroupedTasksAll,
  requestDatapickTasks,
  requestDatapickTasksAll,
  requestInstallationDocumentTasks,
  requestInstallationDocumentTasksAll,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ServiceReport);



// WEBPACK FOOTER //
// ./src/views/ServiceReport.js